import { Decimal } from 'decimal.js';

import {
  EntityKind,
  HypotheticalInsuranceEndsOnKind,
  HypotheticalInsuranceTransferFrequency,
} from '@/types/schema';
import { PathsOf } from '@/types/subform';

import { InsurancePolicyDetailsSubformType } from '../../InsurancePolicyDetailsSubform/InsurancePolicyDetailsSubform.types';

export interface HypotheticalILITFormModalShape {
  /** Set to null if this is a new hypothetical ILIT */
  id: string | null;

  _createANewHypotheticalTrust: boolean;

  /** This maps to `displayName` on the `HypotheticalInsurance` type. */
  transferName: string;

  destinationEntityId: string | '';
  destinationEntityType: EntityKind | '';
  destinationEntityName: string;
  destinationEntityGrantor: string | '';

  /**
   * If the user has selected an existing policy, store it here.  If creating
   * a hypothetical policy, this value will be null.
   */
  existingInsurancePolicyId: string | '';
  /**
   * If the hypothetical insurance entity has created a new policy & saved,
   * then this field represents the ID of the created policy.  If the policy selected
   * an existing policy (eg: from another non-hypothetical entity), this field
   * will be null.
   *
   * If editing an existing hILIT, the presence of a value here means the user
   * should be able to edit the insurance policy.
   */
  createdInsurancePolicyId: string | null;

  startYear?: number;
  endYear?: number;
  endsOnKind: HypotheticalInsuranceEndsOnKind;

  /**
   * Can be an entity or individual; this maps to `sourceEntityID` or `sourceIndividualID` on the
   * `HypotheticalInsurance` type.
   */
  transferFromId: string;

  transferFrequency: HypotheticalInsuranceTransferFrequency;
  /*
   * This value can be one of the following:
   * - `HypotheticalInsuranceTransferTaxKind.AnnualExclusionGiftWithCrummeyPowers`
   * - BOTH_GRANTORS_SENTINEL (if there are multiple grantors)
   * - The ID of the grantor
   */
  transferTaxKind: string;
  transferValue: Decimal | null;

  /**
   * This is so the subform can be used to populate the hypothetical insurance policy
   */
  insurancePolicyDetailsSubform: InsurancePolicyDetailsSubformType;

  _hypotheticalInsurancePolicyType: HypotheticalILITInsurancePolicyType | null;
}

export enum HypotheticalILITInsurancePolicyType {
  Existing = 'existing',
  New = 'new',
}

export type HypotheticalILITFormModalShapePaths =
  PathsOf<HypotheticalILITFormModalShape>;
